import { render, staticRenderFns } from "./JResetPwd.vue?vue&type=template&id=08743d58"
import script from "./JResetPwd.vue?vue&type=script&lang=js"
export * from "./JResetPwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports